import CloseIcon from "@mui/icons-material/Close";
import FullscreenIcon from "@mui/icons-material/Fullscreen";
import FullscreenExitIcon from "@mui/icons-material/FullscreenExit";
import {
  Box,
  Divider,
  IconButton,
  Stack,
  styled,
  Tab,
  Tabs,
  Theme,
  Tooltip,
} from "@mui/material";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import routes from "developer/routes";
import { ChangeEvent, useCallback } from "react";
import { useHistory } from "react-router-dom";
import { useAppSelector } from "store/hooks";
import { EditorModeTab } from "../../constants";
import VisualEditorActions from "./VisualEditorActions";

interface IEditorToolbar {
  tabSelected: EditorModeTab;
  onVisualEditorClick: () => void;
  onFullscreenClick: () => void;
  onSaveClick: () => void;
  onCodeEditorClick: () => void;
  onPreviewClick: () => void;
  onShowKeyboardActions: () => void;
}

const AntTab = styled(Tab)({
  fontSize: 12,
});

const EditorToolbar = (props: IEditorToolbar) => {
  const history = useHistory();

  const { tabSelected } = props;

  const { showFullscreen } = useAppSelector(
    (state) => state.developer.edit.toolbar
  );

  const handleChangeTabEditorMode = useCallback(
    (event: ChangeEvent<{}>, value: number) => {
      value === EditorModeTab.CodeEditor && props.onCodeEditorClick();
      value === EditorModeTab.VisualEditor && props.onVisualEditorClick();
      value === EditorModeTab.Preview && props.onPreviewClick();
    },
    [props]
  );

  const handleClickCloseEditor = useCallback(() => {
    history.push(routes.FORM_DEFINITIONS);
  }, [history]);

  return (
    <Paper
      square
      elevation={0}
      sx={{
        flexGrow: 1,
        padding: (theme: Theme) => theme.spacing(1),
      }}
    >
      <Grid container alignItems="center">
        <Grid item>
          <Tabs
            value={tabSelected}
            onChange={handleChangeTabEditorMode}
            indicatorColor="primary"
            textColor="primary"
          >
            <AntTab label="Visual Editor" />
            <AntTab label="Preview" />
            <AntTab label="Code Editor" />
          </Tabs>
        </Grid>
        <Divider
          orientation="vertical"
          variant="middle"
          flexItem
          sx={{ marginX: (theme: Theme) => theme.spacing(2) }}
        />
        <Grid item container xs>
          {tabSelected === EditorModeTab.VisualEditor && (
            <VisualEditorActions />
          )}
        </Grid>
        <Grid item>
          <Stack direction="row" spacing={1}>
            <Button
              variant="outlined"
              color="primary"
              size="small"
              onClick={props.onSaveClick}
              sx={{ mr: 1 }}
            >
              Save
            </Button>
            <Divider orientation="vertical" variant="middle" flexItem />
            <Box>
              {showFullscreen ? (
                <IconButton size="small" onClick={props.onFullscreenClick}>
                  <Tooltip title="Exit Fullscreen">
                    <FullscreenExitIcon />
                  </Tooltip>
                </IconButton>
              ) : (
                <>
                  <IconButton size="small" onClick={props.onFullscreenClick}>
                    <Tooltip title="Fullscreen">
                      <FullscreenIcon />
                    </Tooltip>
                  </IconButton>

                  <IconButton size="small" onClick={handleClickCloseEditor}>
                    <Tooltip title="Close">
                      <CloseIcon />
                    </Tooltip>
                  </IconButton>
                </>
              )}
            </Box>
          </Stack>
        </Grid>
      </Grid>
    </Paper>
  );
};

export default EditorToolbar;
